/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ConnectStatusResponseDto,
  ErrorResponse,
  OnboardingResponseDto,
  RequestTransferDto,
  TransferListResponseDto,
  TransferResponseDto,
  UpdatePaymentInfoResponseDto,
} from '../models/index';
import {
    ConnectStatusResponseDtoFromJSON,
    ConnectStatusResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    OnboardingResponseDtoFromJSON,
    OnboardingResponseDtoToJSON,
    RequestTransferDtoFromJSON,
    RequestTransferDtoToJSON,
    TransferListResponseDtoFromJSON,
    TransferListResponseDtoToJSON,
    TransferResponseDtoFromJSON,
    TransferResponseDtoToJSON,
    UpdatePaymentInfoResponseDtoFromJSON,
    UpdatePaymentInfoResponseDtoToJSON,
} from '../models/index';

export interface GetTransferRequest {
    id: string;
}

export interface GetTransferHistoryRequest {
    page: string;
    limit: string;
}

export interface RequestTransferRequest {
    requestTransferDto: RequestTransferDto;
}

/**
 * 
 */
export class PracticeConnectApi extends runtime.BaseAPI {

    /**
     * Returns the current status of the practice\'s Stripe Connect account, including whether onboarding is complete and if payouts are enabled.
     * Get Stripe Connect account status
     */
    async getStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConnectStatusResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-connect/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConnectStatusResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns the current status of the practice\'s Stripe Connect account, including whether onboarding is complete and if payouts are enabled.
     * Get Stripe Connect account status
     */
    async getStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConnectStatusResponseDto> {
        const response = await this.getStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns details of a single transfer.
     * Get a specific transfer by ID
     */
    async getTransferRaw(requestParameters: GetTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransferResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTransfer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-connect/transfers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransferResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns details of a single transfer.
     * Get a specific transfer by ID
     */
    async getTransfer(requestParameters: GetTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransferResponseDto> {
        const response = await this.getTransferRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a paginated list of all transfers/payouts for the practice.
     * Get transfer history for practice
     */
    async getTransferHistoryRaw(requestParameters: GetTransferHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransferListResponseDto>> {
        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling getTransferHistory().'
            );
        }

        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling getTransferHistory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-connect/transfers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransferListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns a paginated list of all transfers/payouts for the practice.
     * Get transfer history for practice
     */
    async getTransferHistory(requestParameters: GetTransferHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransferListResponseDto> {
        const response = await this.getTransferHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generates a new onboarding link if the previous one expired (links are valid for 24 hours).
     * Refresh onboarding link if expired
     */
    async refreshOnboardingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OnboardingResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-connect/refresh-onboarding`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OnboardingResponseDtoFromJSON(jsonValue));
    }

    /**
     * Generates a new onboarding link if the previous one expired (links are valid for 24 hours).
     * Refresh onboarding link if expired
     */
    async refreshOnboarding(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OnboardingResponseDto> {
        const response = await this.refreshOnboardingRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates a transfer from the platform to the practice\'s Stripe Connect account. The practice must have completed onboarding before requesting transfers.
     * Request a payout/transfer to practice bank account
     */
    async requestTransferRaw(requestParameters: RequestTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransferResponseDto>> {
        if (requestParameters['requestTransferDto'] == null) {
            throw new runtime.RequiredError(
                'requestTransferDto',
                'Required parameter "requestTransferDto" was null or undefined when calling requestTransfer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-connect/request-transfer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestTransferDtoToJSON(requestParameters['requestTransferDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransferResponseDtoFromJSON(jsonValue));
    }

    /**
     * Creates a transfer from the platform to the practice\'s Stripe Connect account. The practice must have completed onboarding before requesting transfers.
     * Request a payout/transfer to practice bank account
     */
    async requestTransfer(requestParameters: RequestTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransferResponseDto> {
        const response = await this.requestTransferRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a Stripe Connect account (if needed) and returns an onboarding URL. The doctor will complete bank account setup on Stripe\'s hosted page.
     * Start Stripe Connect onboarding for practice
     */
    async startOnboardingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OnboardingResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-connect/start-onboarding`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OnboardingResponseDtoFromJSON(jsonValue));
    }

    /**
     * Creates a Stripe Connect account (if needed) and returns an onboarding URL. The doctor will complete bank account setup on Stripe\'s hosted page.
     * Start Stripe Connect onboarding for practice
     */
    async startOnboarding(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OnboardingResponseDto> {
        const response = await this.startOnboardingRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates a secure login link for the practice to update their connected bank account information in Stripe\'s interface. The practice must have completed onboarding before requesting an update link.
     * Get login link to update payment information
     */
    async updatePaymentInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdatePaymentInfoResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-connect/update-payment-info-link`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdatePaymentInfoResponseDtoFromJSON(jsonValue));
    }

    /**
     * Creates a secure login link for the practice to update their connected bank account information in Stripe\'s interface. The practice must have completed onboarding before requesting an update link.
     * Get login link to update payment information
     */
    async updatePaymentInfo(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdatePaymentInfoResponseDto> {
        const response = await this.updatePaymentInfoRaw(initOverrides);
        return await response.value();
    }

}
